import { AssetEntity, AssetType } from 'src/modules/assets';
import React, { useMemo } from 'react';
import styles from './FileNameAndThumbnail.module.scss';
import classnames from 'classnames';
import {
  isFabricMaterialAsset,
  isLeatherMaterialAsset,
  isMaterialAsset,
  isSurfaceMaterialAsset,
} from 'src/modules/assets/utils';

export interface FileNameAndThumbnailProps {
  asset: AssetEntity;
  onClick?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const FileNameAndThumbnail = ({ asset, onClick }: FileNameAndThumbnailProps) => {
  let thumbnailStyle = {};

  if (asset.type === AssetType.Image) {
    thumbnailStyle = { backgroundImage: `url(${asset.file?.formats?.thumbnail.url})` };
  }

  if (isFabricMaterialAsset(asset)) {
    thumbnailStyle = { backgroundImage: `url(/images/assets/materials/fabric.svg)` };
  } else if (isSurfaceMaterialAsset(asset)) {
    thumbnailStyle = { backgroundImage: `url(/images/assets/materials/surface.svg)` };
  } else if (isLeatherMaterialAsset(asset)) {
    thumbnailStyle = { backgroundImage: `url(/images/assets/materials/leather.svg)` };
  }

  const thumbnailText = useMemo(() => {
    switch (asset.type) {
      case AssetType.CAD:
        return asset.subtype || asset.file?.ext.slice(1);

      case AssetType.PDF: {
        if (isMaterialAsset(asset)) {
          return '';
        }

        return 'pdf';
      }

      default:
      case AssetType.Image:
        return '';
    }
  }, [asset]);

  return (
    <div
      className={classnames(styles.fileNameAndThumbnail, onClick && styles.clickable)}
      onClick={onClick}>
      <div
        className={classnames(styles.thumbnail, styles[`assetType_${asset.type}`])}
        style={thumbnailStyle}>
        {thumbnailText}
      </div>
      <div className={styles.fileCaption}>
        {asset.name || asset.file?.caption || asset.file?.name}
      </div>
    </div>
  );
};
